<template>
  <div class="ModalTable">
    <table
      class="TB_COLLAPSE"
      width="100%"
      v-for="(item, index) in columns"
      :key="index"
    >
      <thead>
        <tr>
          <th
            v-for="it in item"
            :key="it.title"
          >{{ it.title }}</th>
        </tr>
      </thead>
      <tbody>
        <tr :class="{ timerout: trColorStatus }">
          <td
            width="10%"
            v-for="(it, index) in item"
            :key="it.index"
            class="pr-2 pl-2"
          >
            <Select
              ref="Select"
              v-model="Select[it.index]"
              filterable
              @on-query-change="queryChange"
              :not-found-text="notFoundText"
              :disabled="timeLodingStatus === 2"
            >
              <Option value="-">未指定</Option>
              <Option
                v-for="i in NumberSelect(Select[it.index])"
                :key="it.title + i"
                :value="i"
              >{{ i }}</Option>
            </Select>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

import modalTableGame from '@/mixins/modal-table-game.js'
import { Utile } from 'utils'
export default {
  name: 'ModalTableKeno',
  extends: modalTableGame,
  data () {
    return {
      Select: ['-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-'],
      NumberLength: 20,
      NumberBallRange: [80, 1],
      BallAll: false, // 开啟 不重复球号状态
    }
  },
  computed: {
    columns () {
      const result = Array.from({ length: 20 }, (v, i) => {
        return {
          index: i,
          title: `第${(i + 1)}球`,
          align: 'center',
          width: '80',
          key: 'ball',
        }
      })
      return Utile.chunk(result, 10)
    }
  }
}
</script>